import { createFileRoute } from '@tanstack/react-router';
import { FazendasView } from '@/modules/agronomia/components/FazendasView';

// Tela 02 · Fazendas do produtor.
export const Route = createFileRoute('/_authed/agronomia_/produtores_/$cpf')({
  component: Page,
});

function Page() {
  const { cpf } = Route.useParams();
  return <FazendasView cpf={cpf} />;
}
